import { Content } from '../../types';

export const generalThailandContent: Content = {
  title: 'תאילנד - תעודת זהות',
  imageUrl: '/images/thailand/general-thailand/general-thailand-wide.jpeg',
  introduction: `תאילנד שוכנת בדרום מזרח אסיה, בין הודו לסין וגובלת עם קמבודיה, לאוס, מיאנמר ומלזיה.
משמעות השם תאילנד הינה ארץ החופש, ייתכן כי הדבר מתייחס לגאוות העם התאילנדי על כך שמדינתו הינה היחידה מבין כל מדינות דרום - מזרח אסיה שלא נכבשה מעולם  ולכן מכונה "ארץ החופשיים".
שמה הקדום של המדינה הינה ממלכת סיאם (עד 1939).`,
  sections: [
    {
      title: 'נתונים כלליים',
      content: `שטח הממלכה הינו כ - 513 אלף קמ"ר - פי 25 משטחה של  מדינת ישראל ולתאילנד חופים באורך 3,220 קילומטר, מפרץ תאילנד במזרח וים אנדמן במערב. 
כ - 72 מליון תושבים חיים ב - 77 מחוזותיה של תאילנד וכ - 10 מליון מתוכם חיים בעיר הבירה בנגקוק, עיר ענקית ומיוחדת המהווה את המרכז הפוליטי, הכלכלי והתרבותי של המדינה.
הדת המרכזית במדינה הינה הדת הבודהיסטית (כ - 95% מהתושבים), השפה הינה תאית והמטבע המקומי הינו הבאט (Bath), סימול בנקאי - THB (בהשוואה למטבע הישראלי, 10 באט = 1.1 ₪.
שעון תאילנד מקדים את שעון ישראל בחמש שעות בזמן שעון חורף ובארבע שעות בזמן שעון קיץ.`,
      type: 'text',
    },
    {
      title: 'Victory Monoment',
      content: '',
      type: 'image',
      imageUrl:
        '/images/thailand/general-thailand/general-thailand-article-1.jpeg',
    },
    {
      title: 'אזורים גיאוגרפיים',
      content: `חמישה אזורים עיקריים בתאילנד: צפון, צפון מזרח (איסאן), מזרח, מרכז ודרום, בהם ניתן לטייל במהלך כל השנה אך מאחר ובתאילנד מספר אזורי מזג אוויר שונים זה מזה, מומלץ להתאים את תקופת הטיול לאזורים המתאימים ועם זאת, יש לזכור כי מדובר במזג אוויר טרופי אשר, ככלל, אינו ניתן לחיזוי.

האזורים העיקריים בהם מבקרים התיירים הישראלים הינם הצפון אשר הינו אזור הררי ושופע אטרקציות בטבע (צ'אנג מאי, פאי, צ'אנג ראי ועוד), המרכז, המכונה "קערת האורז של המדינה" (בנגקוק וסביבותיה, פטאיה, הואה הין, קנצ'נבורי ועוד) והדרום אשר מכיל בעיקר את האיים המזרחיים במפרץ תאילנד (סאמוי, פנגן וטאו) ואת האיים המערביים לאורך ים אנדמן (ליפה, לנטה, פיפי, פוקט, קראבי, קאו לאק וקאו סוק). כיום, מתפתח אזור צפון מזרח המדינה (איסאן) כאזור תיירותי נוסף.`,
      type: 'text',
    },
    {
      title: 'שמורות טבע',
      content: `בתאילנד, כ - 150 שמורות טבע/ פארקים לאומיים המנוהלים ע"י משרד המשאבים הטבעיים והסביבה. השמורה הראשונה שהוכרזה הינה קאו יאי (1961), הגדולה הינה קאנג קרצ'ן והמפורסמת ביותר הינה קאו סוק ובכללה אגם צ'או לן.`,
      type: 'text',
    },
    {
      title: 'כלכלה',
      content: `הכלכלה הקלאסית מושתתת בעיקר על ענף המזון (אורז, אגוזי קשיו, אננס, דגים ועוד) ואילו זו המודרנית כוללת ענפי תעשייה רבים כאלקטרוניקה, מחשבים, כלי רכב, טקסטיל וכמובן תיירות. הכלכלה התאילנדית כיום הינה אחת המשגשגות בדרום מזרח אסיה.`,
      type: 'text',
    },
    {
      title: 'אקלים',
      content: `האקלים בתאילנד הינו טרופי, חם ולח עם עונה ארוכה של מונסונים. קיימות שלוש עונות עיקריות: העונה היבשה - מנובמבר עד פברואר, העונה החמה - ממרץ עד מאי והעונה הגשומה - מיוני עד אוקטובר.`,
      type: 'text',
    },
    {
      title: 'מערכת הבריאות',
      content: `לתאילנד מערכת בריאות מתקדמת ביותר. בערים הגדולות, דגש על בנגקוק ובכלל אתרי התיירות, קיימים בתי חולים ומרפאות ובכללם בתי חולים בינלאומיים, מודרניים ומתקדמים ביותר. רשת בתי החולים Bangkok Hospital הפרוסה בכל רחבי המדינה ובית החולים Bumrungrad בבנגקוק, הינם המומלצים לכל אירוע רפואי.`,
      type: 'text',
    },
    {
      title: 'יהדות בתאילנד',
      content: `החל מתחילת שנות ה - 90 החלה תנועת חב"ד בראשות הרב יוסף חיים קנטור את פעילותה במדינה. כיום, קיימים שבעה בתי חב"ד בתאילנד (בבנגקוק ליהודים מקומיים, בנגקוק לישראלים, פוקט, קו סאמוי, צ'אנג מאי, פאי וקופנגן).

כיום, קיים מערך כשרות מלא בתאילנד, חינוך יהודי מלא - החל מהגן ועד בי"ס תיכון וישיבה אורתודוקסית וכן בית קברות יהודי. את כלל הפרטים בכל הקשור ליהדות בתאילנד, ניתן למצוא באתר הקהילה היהודית <a href="https://www.jewishthailand.com" target="_blank">jewishthailand.com</a> ובאתר בית חב"ד תאילנד <a href="http://chabadthailand.co.il/" target="_blank">chabadthailand.co.il</a> .`,
      type: 'text',
    },
  ],
};
